import { ApolloClient } from '@apollo/client';

import {
  ACTIVITIES_CONTENT_STATUS_DRAFT,
  LANGUAGE_CODE_EN_AU,
  SubActivitiesLabelType,
} from 'global/constants';
import { ComponentSubActivity } from '../component.constants';
import { getSubActivityLabel } from '../sub-activity/sub-activity.utils';

export function updateSubActivityLabelInCache(
  client: ApolloClient<any>,
  type: SubActivitiesLabelType,
  index: number,
  subActivity: ComponentSubActivity
) {
  client.cache.modify({
    id: client.cache.identify({
      id: subActivity.id,
      __typename: subActivity.__typename,
      language: LANGUAGE_CODE_EN_AU,
      version: ACTIVITIES_CONTENT_STATUS_DRAFT,
    }),
    fields: {
      subActivityProperties(existing) {
        return {
          ...existing,
          subActivityLabel: getSubActivityLabel(type, index),
        };
      },
    },
  });
}
